<div class="request-opening-template-container" *ngIf="!isLoadingLabels && !isLoadingTemplates">
	<div class="search" *ngIf="selectedTemplate.id == undefined">
		<cpi-input-with-autocomplete
			[availableOptions]="availableTemplatesIAC"
			[minInputLength]="0"
			[placeholder]="labels.lbl_geral_buscar"
			[keepValue]="false"
			(onValueChange)="setTemplate($event)">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="availableTemplates"
			[height]="'45dvh'"
			[itemPadding]="'1%'"
			[insideSort]="true"
			[labels]="labels"
			(getSelectedItem)="setTemplate($event[0]['id'])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="resetSelectedTemplate(true)">{{ labels.lbl_kb_criar + ' template' }}</div>
		</div>
	</div>

	<ng-container *ngIf="selectedTemplate.id != undefined">
		<div class="header-wrap">
			<div class="tab selected">{{ labels.lbl_template_abertura_chamado }}</div>
		</div>
		<div class="body-wrap">
			<ng-container *ngIf="selectedTemplate.id != undefined">
				<div class="dotted-input-container">
					<span
						>{{ labels.lbl_geral_id_template }}
						<fa-icon [icon]="icons.faInfoCircle" [title]="labels.lbl_geral_explicacao_id_template"></fa-icon
					></span>
					<input [value]="selectedTemplate.id" (input)="selectedTemplate.id = $event.target.value" disabled />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_nome }} *</span>
					<input [value]="selectedTemplate.name" (input)="selectedTemplate.name = $event.target.value" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_summary }} *</span>
					<input [value]="selectedTemplate.summary" (input)="selectedTemplate.summary = $event.target.value" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_chamado_confidencial }}</span>
					<cpi-checkbox
						[value]="this.selectedTemplate.confidential_request"
						(oValue)="this.selectedTemplate.confidential_request = $event"
						[innerText]="this.selectedTemplate.confidential_request ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_descricao }}</span>
					<textarea rows="4" (input)="selectedTemplate.description = $event.target.value">{{
						selectedTemplate.description
					}}</textarea>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_descricao_justificativa_obrigatoria }}</span>
					<cpi-checkbox
						[value]="this.selectedTemplate.description_required"
						(oValue)="this.selectedTemplate.description_required = $event"
						[innerText]="this.selectedTemplate.description_required ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_informativo }}</span>
					<angular-editor [config]="editorConfig" [(ngModel)]="selectedTemplate.informative"> </angular-editor>
					<!-- <textarea rows="4" (input)="selectedTemplate.informative = $event.target.value">{{selectedTemplate.informative}}</textarea> -->
				</div>

				<div class="label">{{ labels.lbl_geral_classificacao }} *</div>

				<pcp-request-classification-reverse-rmk
					[hideField]="classificationOptions.hideField"
					[alertField]="classificationOptions.alertField"
					[idCustomerList]="classificationOptions.selectedCustomer"
					[setClassificationId]="classificationIds"
					(getClassification)="setClassification($event)">
				</pcp-request-classification-reverse-rmk>
			</ng-container>

			<div class="button-container">
				<div class="button" (click)="resetSelectedTemplate(false)">{{ labels.lbl_geral_voltar }}</div>
				<div class="button" (click)="resetSelectedTemplate(true)">{{ labels.lbl_chat_limpar + ' template' }}</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingTemplate }"
					(click)="createTemplate()"
					*ngIf="selectedTemplate.id === '0'">
					{{ labels.lbl_kb_criar }} template
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingTemplate"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingTemplate }"
					(click)="confirmDelete.classList.contains('confirmClick') ? deleteTemplate() : confirmButton(confirmDelete)"
					#confirmDelete
					*ngIf="selectedTemplate.id != undefined && selectedTemplate.id != '0'">
					{{ labels.lbl_geral_excluir }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingTemplate"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingTemplate }"
					(click)="updateTemplate()"
					*ngIf="selectedTemplate.id != undefined && selectedTemplate.id != '0'">
					{{ labels.lbl_geral_atualizar }} template
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingTemplate"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="isLoadingLabels || isLoadingTemplates"></cpi-dot-bounce-loading-effect>
